import { jsx as _jsx } from "react/jsx-runtime";
export default function HomePage() {
  return /*#__PURE__*/_jsx("p", {});
}